module.exports = __webpack_public_path__ + "img/public/SiteIcons/noItemCars.svg?bad091a5";